/* ==========================================================================
   TrendyBits · per-variant personalisation
   --------------------------------------------------------------------------
   The personalisation card rendered by sections/tb-personalise.liquid belongs
   to the whole product: tag a product "custom-text" and every variant of it
   asks for a name. That is wrong for a product sold two ways — a keychain you
   can buy plain or with a name cut into it, a mug blank or printed. The plain
   variant should not demand text, and it must not be blocked by the required
   field either.

   Nothing in the theme is variant-aware, so this file adds that layer without
   touching either the section or assets/tb-personalise.js.

   HOW TO SWITCH IT ON
   Set the product metafield  custom.personalisation_variants  to a comma
   separated list of the option values that need the text field, exactly as
   they are spelled in the variant picker (matching ignores case and extra
   spaces). Example: "With Name, With Two Names". Leave the metafield empty and
   this file is never even requested — snippets/meta-tags.liquid only loads it
   when the metafield has a value — so existing products behave as before.

   HOW IT WORKS
   sections/tb-pdp.liquid marks the chosen option value with class "active" on
   a button.tb-pdp__variant inside a [data-pdp-option-index] group, and fires
   no event when it changes. So this listens for clicks on those buttons in the
   bubble phase and re-reads the active buttons on the next tick, after the
   section's own handler has moved the class.

   When the selected combination is not personalisable the card is hidden and
   each input is disabled AND has its .tbpz__in class swapped for
   .tbpz__in--off. Both matter:
     · disabled keeps the value out of the submitted form and switches off the
       browser's own "required" validation, so checkout is not blocked by a
       field nobody can see;
     · the class swap is what tells assets/tb-personalise.js to ignore the
       field. Its paint() looks the input up with f.querySelector('.tbpz__in')
       and skips the field when that returns null, so the buy button unlocks on
       its own instead of staying greyed out.
   Switching back restores the class, re-enables the input and fires one input
   event so paint() recomputes the counter, the preview line and the lock.

   To disable everything here: delete the two script lines from
   snippets/meta-tags.liquid, or clear the metafield on the product.
   ========================================================================== */

(function () {
  'use strict';

  var cfgEl = document.getElementById('tb-custom-variants-cfg');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent) || {};
  } catch (e) {
    return;
  }

  function norm(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  var wanted = String(CFG.onlyFor || '')
    .split(',')
    .map(norm)
    .filter(function (v) { return v.length > 0; });

  /* No list means "every variant is personalisable" — the original behaviour. */
  if (!wanted.length) return;

  var last = null;

  function selectedValues() {
    var out = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-pdp-option-index]'),
      function (group) {
        var active = group.querySelector('.tb-pdp__variant.active');
        if (active) out.push(norm(active.getAttribute('data-option-value')));
      }
    );
    return out;
  }

  function isPersonalisable() {
    var vals = selectedValues();
    /* A product with no option pickers has one variant — treat it as custom. */
    if (!vals.length) return true;
    for (var i = 0; i < vals.length; i++) {
      if (wanted.indexOf(vals[i]) !== -1) return true;
    }
    return false;
  }

  function apply(force) {
    var card = document.querySelector('[data-tbpz-card]');
    if (!card) return false;

    var on = isPersonalisable();
    if (on === last && !force) return true;
    last = on;

    var inputs = card.querySelectorAll('.tbpz__in, .tbpz__in--off');
    Array.prototype.forEach.call(inputs, function (input) {
      if (on) {
        input.classList.remove('tbpz__in--off');
        input.classList.add('tbpz__in');
        input.disabled = false;
        if (input.getAttribute('data-tbcv-required') === '1') {
          input.setAttribute('required', 'required');
          input.removeAttribute('data-tbcv-required');
        }
      } else {
        if (input.hasAttribute('required')) {
          input.setAttribute('data-tbcv-required', '1');
          input.removeAttribute('required');
        }
        input.disabled = true;
        input.classList.remove('tbpz__in');
        input.classList.add('tbpz__in--off');
      }
    });

    card.style.display = on ? '' : 'none';
    card.setAttribute('aria-hidden', on ? 'false' : 'true');

    var submit = document.querySelector('[data-pdp-submit]');
    var note = document.querySelector('[data-tbpz-note]');

    if (on) {
      /* Let tb-personalise.js recompute the lock, counters and preview line. */
      var first = card.querySelector('.tbpz__in');
      if (first) {
        first.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } else {
      /* Nothing to fill in, so nothing should look locked. */
      if (submit && !submit.hasAttribute('data-sold-out')) {
        submit.classList.remove('tbpz-locked');
        submit.setAttribute('aria-disabled', 'false');
      }
      if (note) note.style.display = 'none';
      card.classList.remove('is-bad');
    }

    return true;
  }

  /* The card is relocated into the form by tb-personalise.js on DOMContentLoaded,
     so poll briefly rather than assume it is there on the first pass. */
  var tries = 0;
  function boot() {
    if (apply(true)) return;
    if (++tries > 25) return;
    setTimeout(boot, 100);
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.tb-pdp__variant') : null;
    if (!btn) return;
    if (!btn.closest('[data-pdp-option-index]')) return;
    /* The section sets .active in its own click handler; read it after that. */
    setTimeout(function () { apply(false); }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  } else {
    setTimeout(boot, 0);
  }
})();